import { Anchor, Button, Group, Text } from '@mantine/core';

/**
 * LİSTE MEKANİĞİ (P4 — Kapsam §20.3b).
 *
 * **SAYFALAMA, SONSUZ KAYDIRMA DEĞİL** ve **SÜZGEÇ HATIRLANIR AMA GÖRÜNÜR.**
 *
 * ⚠️ Gerekçe S6.5'in çıktı/toplu yükleme motorlarıyla hizalıdır: *"şu anki
 * süzgeçle 312 kayıt var, hepsini Excel'e ver"* cümlesi **net** olmalı —
 * sonsuz kaydırmada toplam belirsizleşir ve *"hepsini seç"* ne demek belirsiz
 * kalır. Görünür süzgeç de kullanıcının *"ekipmanlarım kaybolmuş"* demesini
 * engeller.
 */

export function SuzgecGostergesi({
  etkinSayisi,
  onTemizle,
  testId = 'suzgec-gostergesi',
}: {
  etkinSayisi: number;
  onTemizle: () => void;
  testId?: string;
}): React.JSX.Element | null {
  if (etkinSayisi === 0) return null;
  return (
    <Group gap="xs" data-testid={testId}>
      <Text size="sm" c="dimmed">
        {etkinSayisi} süzgeç etkin
      </Text>
      <Anchor size="sm" onClick={onTemizle} data-testid={`${testId}-temizle`}>
        temizle
      </Anchor>
    </Group>
  );
}

export function Sayfalama({
  sayfa,
  sayfaBoyutu,
  toplam,
  onDegis,
  testId = 'sayfalama',
}: {
  sayfa: number;
  sayfaBoyutu: number;
  toplam: number;
  onDegis: (sayfa: number) => void;
  testId?: string;
}): React.JSX.Element {
  const sonSayfa = Math.max(1, Math.ceil(toplam / sayfaBoyutu));
  return (
    <Group justify="space-between" data-testid={testId}>
      {/* TOPLAM HER ZAMAN GÖRÜNÜR (P4) — çıktı motorunun cümlesi buradan kurulur. */}
      <Text size="sm" c="dimmed" data-testid={`${testId}-toplam`}>
        Toplam {toplam} kayıt · sayfa {sayfa}/{sonSayfa}
      </Text>
      <Group gap="xs">
        <Button
          size="xs"
          variant="default"
          disabled={sayfa <= 1}
          onClick={() => onDegis(sayfa - 1)}
          data-testid={`${testId}-onceki`}
        >
          Önceki
        </Button>
        <Button
          size="xs"
          variant="default"
          disabled={sayfa >= sonSayfa}
          onClick={() => onDegis(sayfa + 1)}
          data-testid={`${testId}-sonraki`}
        >
          Sonraki
        </Button>
      </Group>
    </Group>
  );
}
